<template>
    <div>
        <div class="text-right mb-4">
            <vs-textarea class="fab-textarea" style="border:1px solid darkgray;" v-model="currentComment" height="160" @input="$emit('input', currentComment)" placeholder="Escreva um comentário...">
            </vs-textarea>
            <vs-button color="primary" @click="$emit('submit')" type="filled">
                <strong>
                    REGISTRAR COMENTÁRIO
                </strong>
            </vs-button>
        </div>
        <p v-if="!hasComments">Nenhum comentário encontrado</p>
        <div v-else>
            <h3>Comentários anteriores</h3>
            <hr />
            <vs-list class="mb-4">
                <vs-list-item v-for="comment in comments" :key="comment.id">
                <div style="display:flex; justify-content: space-between; margin-bottom: 10px;">
                    <strong>
                        {{comment.username}}
                    </strong>
                    <small>
                        {{
                            comment.createdAt | relativeDate
                        }}
                    </small>
                </div>
                {{comment.content}}
                </vs-list-item>
            </vs-list>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Comments',
    data() {
        return {
            currentComment: ''
        };
    },
    props: {
        comments: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        hasComments() {
            return this.comments.length > 0;
        }
    },
    methods: {
        reset() {
            this.currentComment = '';
        }
    }
};
</script>

<style>
    .vs-list--item {
        margin-top: 20px;
        padding: 40px;
        border: 1px solid darkgray;
        border-radius: 5px;
        padding-bottom: 30px;
    }
    .vs-list--slot {
        width: 100%;
    }
    .vs-list--item {
        border: 1px solid darkgray!important;
    }
</style>
